export default __webpack_public_path__ + "static/media/icon-course-approved.6dd99412.svg";